<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
  <path fill="currentColor" d="M6 11l1 1 4-4-4-4-1 1 3 3z"/>
</svg>
</template>

<script>
export default {};
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/IconArrowRight.vue